var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLtConnectionOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 3.5C3.19391 3.5 2 4.69391 2 6.16667V18.5208L2.0001 18.5207C2.0112 19.6157 2.90234 20.5 4 20.5H18.8333C20.3061 20.5 21.5 19.3061 21.5 17.8333V16.3496C21.8147 15.9119 22 15.3749 22 14.7947V6.16667C22 4.69391 20.8061 3.5 19.3333 3.5H4.66667ZM19.958 18L4.13234 18C3.85621 18 3.63235 18.2239 3.63235 18.5C3.63235 18.7761 3.85621 19 4.13234 19H18.6667C19.2879 19 19.81 18.5751 19.958 18ZM15.3333 16.5H3.5V6.33333C3.5 5.59695 4.09695 5 4.83333 5H19.1667C19.903 5 20.5 5.59695 20.5 6.33333V15.1667C20.5 15.903 19.903 16.5 19.1667 16.5H15.3333ZM7 8.75C7 8.33579 7.33579 8 7.75 8H16.25C16.6642 8 17 8.33579 17 8.75C17 9.16421 16.6642 9.5 16.25 9.5H7.75C7.33579 9.5 7 9.16421 7 8.75ZM10.25 11C9.83579 11 9.5 11.3358 9.5 11.75C9.5 12.1642 9.83579 12.5 10.25 12.5H13.75C14.1642 12.5 14.5 12.1642 14.5 11.75C14.5 11.3358 14.1642 11 13.75 11H10.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 17.5,
    r: 4.5,
    fill: "#D45848",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtConnectionOff);
export default __webpack_public_path__ + "static/media/lt-connection-off.989d85fb.svg";
export { ForwardRef as ReactComponent };